package com.siriusxm.pia.views.unifiedaggregator

/**
 * Returns a list of the elements in this [Iterable], sorted alphabetically by the string value
 * returned from [selector]. Comparison is case-insensitive, with a secondary stable tie-breaker
 * that preserves original casing.
 *
 * Trims leading and trailing whitespace before comparison.
 *
 * Example:
 * ```
 * listOf("Beta", "alpha", "  Gamma ").sortedAlphaBy { it }
 * // → ["alpha", "Beta", "Gamma"]
 * ```
 */
inline fun <T> Iterable<T>.sortedAlphaBy(
    crossinline selector: (T) -> String
): List<T> =
    this.sortedWith(
        compareBy<T> { selector(it).trim().lowercase() }
            .thenBy { selector(it).trim() }
    )
